import React from "react";

const HowItWorks = ({ steps }) => {
  return (
    <section className="oshar-re-how" id="oshar-re-how-it-works" aria-labelledby="oshar-re-how-title">
      <div className="oshar-inner">
        <h2 id="oshar-re-how-title" className="oshar-re-section-title">
          How It Works
        </h2>
        <p className="oshar-re-section-lead">
          A guided path from account to NFT — UI first, chain verification after marketplace
          completion.
        </p>
        <ol className="oshar-re-how__steps">
          {steps.map((s) => (
            <li key={s.n} className="oshar-re-how__step">
              <div className="oshar-re-how__num">{s.n}</div>
              <div className="oshar-re-how__content">
                <h3>{s.title}</h3>
                <p>{s.body}</p>
              </div>
            </li>
          ))}
        </ol>
        <p className="oshar-re-how__fineprint">
          Credit card and wallet-based purchase flows can be supported. Final blockchain minting and
          verification will be integrated after the marketplace UI is complete.
        </p>
      </div>
    </section>
  );
};

export default HowItWorks;
